import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NewMessagingChatsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ChatsInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type NewMessagingChatsQuery = { __typename?: 'Query', UnreadChatsCount: number, MyChats: { __typename?: 'Chats', totalCount: number, objects: Array<{ __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> }> } };

export type ChatListItemFragment = { __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> };

export const ChatListItemFragmentDoc = gql`
    fragment ChatListItem on Chat {
  id
  chatType
  viewerIsOwner
  membersCanEditTitle
  membersCanEditMembers
  unreadCount
  title {
    en
  }
  userSelectionSet {
    id
    userSelections {
      id
      userMemberships {
        id
      }
    }
  }
  viewerArchivedAt
  latestMessageText
  latestMessageHasAttachments
  members {
    id
    name
    firstName
    deactivatedAt
    profileImage {
      ...AvatarProfileImage
    }
  }
}
    ${AvatarProfileImageFragmentDoc}`;
export const NewMessagingChatsDocument = gql`
    query NewMessagingChats($input: ChatsInput, $pagination: PaginationInput) {
  UnreadChatsCount
  MyChats(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...ChatListItem
    }
  }
}
    ${ChatListItemFragmentDoc}`;

/**
 * __useNewMessagingChatsQuery__
 *
 * To run a query within a React component, call `useNewMessagingChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewMessagingChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewMessagingChatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useNewMessagingChatsQuery(baseOptions?: Apollo.QueryHookOptions<NewMessagingChatsQuery, NewMessagingChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewMessagingChatsQuery, NewMessagingChatsQueryVariables>(NewMessagingChatsDocument, options);
      }
export function useNewMessagingChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewMessagingChatsQuery, NewMessagingChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewMessagingChatsQuery, NewMessagingChatsQueryVariables>(NewMessagingChatsDocument, options);
        }
export type NewMessagingChatsQueryHookResult = ReturnType<typeof useNewMessagingChatsQuery>;
export type NewMessagingChatsLazyQueryHookResult = ReturnType<typeof useNewMessagingChatsLazyQuery>;
export type NewMessagingChatsQueryResult = Apollo.QueryResult<NewMessagingChatsQuery, NewMessagingChatsQueryVariables>;